"use strict";
exports.__esModule = true;
exports.TokenManager = void 0;
var errorMsg = 'Token Manager is no longer available in TSG based env';
var TokenManager = /** @class */ (function () {
    function TokenManager() {
    }
    TokenManager.getInstance = function (appName) {
      console.warn(errorMsg);
      return new TokenManager();
    };
    TokenManager.init = function (appName, maxNumberOfTenantsPerApp, expirationCheckInterval, timeBeforeExpiration, numberOfRetryForJwt, associations, mandatoryAssociations, optionalAssociations, fqdn, jwtAuth) {
        console.warn(errorMsg);
    };
    TokenManager.prototype.getMaxNumberOfTenantsPerApp = function () {
        throw new Error(errorMsg);
    };
    TokenManager.prototype.hasTenant = function (accountId, tenantId, app) {
        throw new Error(errorMsg);
    };
    TokenManager.prototype.getTenantRegion = function (accountId, tenantId, app) {
        throw new Error(errorMsg);
    };
    TokenManager.prototype.getAssociatedTenantRegion = function (accountId, app, appTenantId, associatedApp, associatedAppTenantId) {
        throw new Error(errorMsg);
    };
    TokenManager.prototype.getAnyExistingJwt = function (accountId) {
        return Promise.reject(new Error(errorMsg));
    };
    TokenManager.prototype.getJwt = function (accountId, requestedTenantByApp) {
        return Promise.reject(new Error(errorMsg));
    };
    TokenManager.prototype.setAuth = function (authData) {
        console.warn(errorMsg);
    };
    return TokenManager;
}());
exports.TokenManager = TokenManager;
exports.default = TokenManager;
